import { app } from '../../app.module'
app
  // アカウントの投稿の対象データ(投稿タイプ、ハッシュタグ、文字数)表示用のディレクティブ
  .directive('accountTarget', ($parse) => {
    return {
      template: require('./account-target.pug')(),
      restrict: 'E',
      controller: function ($rootScope, $scope, $mdDialog, $attrs, AccountTargetService) {
        // 対象タイトルをセット
        $scope.targetTitle = AccountTargetService.Data.setTargetTitle(
          $scope.analyticsTab,
          $scope.snsType
        )
        // アカウント詳細のデータを変更するイベント
        $scope.$watch(
          () => {
            return $scope.analyticsData
          },
          () => {
            if ($scope.analyticsData === undefined || $scope.analyticsData === null) {
              return
            }

            // アカウント詳細をセット
            setAccountTargetData()
          }
        )

        /**
         * setAccountTargetData アカウント詳細をセット
         */
        function setAccountTargetData() {
          $scope.accountDetails = $scope.analyticsData.analytics
          if ($scope.analyticsData.accounts !== null) {
            $scope.accountsCount = $scope.analyticsData.accounts
          }

          // ローディングフラグをfalseにする
          $parse($attrs.onChange)($scope, {
            isLoading: false,
            isPeriodChangeLoading: false,
          })
        }

        /**
         * openPostListModal 投稿一覧モーダルを開く
         * @param {string} targetType 期間
         * @param {string} targetValue SNSタイプ
         */
        $scope.openPostListModal = function (targetType: string, targetValue: string) {
          // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
          const modalScope: {
            target: string
            snsType: string
            getOptions: any
          } = $rootScope.$new()
          modalScope.target = targetValue
          // SNSタイプ
          modalScope.snsType = $scope.snsType

          modalScope.getOptions = JSON.parse(JSON.stringify($scope.getOptions))
          switch (targetType) {
            case 'type':
              modalScope.getOptions.postTypeFilter =
                AccountTargetService.Data.convertPostType(targetValue)
              break

            case 'hashtag':
              modalScope.getOptions.hashtagFilter = targetValue
              break

            case 'characterNumber':
              modalScope.getOptions.targetInfo = {
                type: targetType,
                value: AccountTargetService.Data.convertCharacterNumber(targetValue),
              }
              break

            case 'videoDuration':
              modalScope.getOptions.durationFilter = [
                AccountTargetService.Data.convertVideoDuration(targetValue),
              ]
              break
          }

          // モーダルを表示する
          $mdDialog.show({
            template: require('../post-list-modal/post-list-modal.pug')(),
            scope: modalScope,
            clickOutsideToClose: true,
          })
        }
      },
    }
  })
